import { React, useRef } from "react";
import { useTranslation } from "react-i18next";
import CurrentContract from "../components/CurrentContractType";
import DesireContract from "../components/DesireContractType";
import Mobility from "../components/Mobility";
import RemoteWork from "../components/RemortWork";
import Availability from "../components/Availability";
import ExitReason from "../components/ExitReason";
import OthersProposals from "../components/OtherProposals";
import SalaryInformation from "../components/SalaryInformation";
import CurrentSalary from "../components/CandidateSalary";
import ExpectSalary from "../components/ExpectedSalary";
import IsNegotiable from "../components/IsNegotialble";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { ValidateFields } from "../ValidateFields";
import CurrentSalaryIsLiquid from "../components/CurrentSalaryIsLiquiq";
import SalaryExpectedIsLiquid from "../components/SalaryExpectedIsLiquid";
import { Row } from "react-bootstrap";
import { serializeObject } from "../../../../common/helper";

export function Conditions({ changeCardStatus, cardStatus }) {
  let mobilityRef = useRef();
  const { t } = useTranslation();
  const { searchObject, setSearchObject, onChange } = useAdvanceSearchContext();

  function clearCondition() {
    searchObject.desiredContractTypeId = undefined;
    searchObject.currentContractTypeId = undefined;
    searchObject.remoteWorkId = undefined;
    searchObject.AvailabilityStatusId = undefined;
    searchObject.noticeId = undefined;
    searchObject.exitReason = undefined;
    searchObject.otherProposals = undefined;
    searchObject.salaryInformation = undefined;
    searchObject.lowerBoundCurrentSalary = undefined;
    searchObject.upperBoundCurrentSalary = undefined;
    searchObject.lowerBoundSalary = undefined;
    searchObject.upperBoundSalary = undefined;
    searchObject.isNegotiable = undefined;
    searchObject.currentSalaryValueIsLiquid = undefined;
    searchObject.salaryExpectedValueIsLiquid = undefined;
    searchObject.mobility = undefined;
    if (mobilityRef.current) {
      mobilityRef.current.reset();
    }

    setSearchObject({
      ...searchObject
    });
  }

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionConditions"
          >
            {`${t("Conditions")} ${ValidateFields.condition(searchObject)}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <Row>
              <div className="col-md-4">
                <CurrentContract
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-2">
                <CurrentSalary
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-2">
                <CurrentSalaryIsLiquid
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <DesireContract
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-2">
                <ExpectSalary
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-2">
                <SalaryExpectedIsLiquid
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <SalaryInformation
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <RemoteWork
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <Mobility
                  ref={mobilityRef}
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <Availability
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
              {searchObject.AvailabilityStatusId === 3 && (
                <div className="negotiable-position">
                  <IsNegotiable
                    searchObject={searchObject}
                    setSearchObject={setSearchObject}
                    t={t}
                  />
                </div>
              )}
            </Row>
            <Row style={{ marginTop: "200px" }}>
              <div className="col-md-4">
                <ExitReason
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <OthersProposals
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
          </div>
          <div className="text-end button-clear-position">
            <button
              className="app-button btn-second btn-md"
              onClick={clearCondition}
            >
              {t("Clear Conditions")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
